import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const CustomToolModal = ({
  open,
  onClose,
  onSave,
  title = "Add Custom Tool",
  inputLabel = "Tool Name",
  buttonText = "Save Tool",
}) => {
  const [toolName, setToolName] = useState("");

  const handleClose = () => {
    setToolName("");
    onClose();
  };

  const handleSave = () => {
    if (toolName.trim()) {
      onSave(toolName);
      setToolName("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={inputLabel}
          type="text"
          fullWidth
          variant="outlined"
          value={toolName}
          onChange={(e) => setToolName(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!toolName.trim()}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomToolModal;
